// extracted by css-extract-rspack-plugin
export default {"subscribed":"ProductButton-module__subscribed--MhlW_"};